<template>
  <div class="card flex fd-c fgap2">
    <div class="filter-header">
      <div class="filter-header__info">
        <h4 class="text-uppercase text-medium">
          PAINEL GERAL DE INDICADORES DOS PROCESSOS DE IMPORTAÇÃO
        </h4>
        <p class="text-light">
          Selecione um período ao lado se deseja buscar períodos diferentes
        </p>
      </div>
      <div class="filter-header__controls">
        <div>
          <Select
            v-model="startDateInput"
            :useDate="true"
            :useIcon="true"
            title="Data Inicial"
          >
            <template #icon>
              <CalendarIcon/>
            </template>
          </Select>
        </div>
        <div>
          <Select
            v-model="endDateInput"
            :useDate="true"
            :useIcon="true"
            title="Data Final"
          >
            <template #icon>
              <CalendarIcon/>
            </template>
          </Select>
        </div>
        <div class="filter-header__field--companies">
          <Select
            v-model="selectedCompaniesIds"
            :multiple="true"
            :classLi="'blured-select-list'"
            :options="userCompanies"
            title="Empresas"
          />
        </div>
        <div>
          <button class="btn solid primary"
                  @click="filtrarIndicadores(startDateInput, endDateInput)">
            Filtrar
          </button>
        </div>
      </div>
    </div>

    <div
      class="medium-border-radius light-bordered offwhite-bg p-2 flex fd-c fgap2"
    >
      <div>
        <h4 class="text-uppercase text-medium flex ai-c jc-sb">
          <span> TOTAL DE PROCESSOS DE IMPORTAÇÃO </span>
          <span> {{ stepsIndicators.total }} PROCESSOS EM ANDAMENTO </span>
        </h4>
        <p class="text-light">Quantidade total de processos por etapas</p>
      </div>

      <div class="steps-cards-row flex fgap2 fw-w">
        <StepCard
          :animated="true"
          :processes="stepsIndicators.inProduction"
          :selectedCompaniesIds="selectedCompaniesIds"
          :stepNumber="7"
          class="flex1"
          stepName="Produção"
        />
        <StepCard
          :animated="true"
          :processes="stepsIndicators.inBooking"
          :selectedCompaniesIds="selectedCompaniesIds"
          :stepNumber="1"
          class="flex1"
          stepName="Booking"
        />
        <StepCard
          :animated="true"
          :processes="stepsIndicators.inTraffic"
          :selectedCompaniesIds="selectedCompaniesIds"
          :stepNumber="2"
          class="flex1"
          stepName="Trânsito"
        />
        <StepCard
          :animated="true"
          :processes="stepsIndicators.inClearence"
          :selectedCompaniesIds="selectedCompaniesIds"
          :stepNumber="3"
          class="flex1"
          stepName="Desembaraço"
        />
        <StepCard
          :animated="true"
          :processes="stepsIndicators.inLoading"
          :selectedCompaniesIds="selectedCompaniesIds"
          :stepNumber="4"
          class="flex1"
          stepName="Carregamento"
        />
        <StepCard
          :animated="true"
          :processes="stepsIndicators.inClosure"
          :selectedCompaniesIds="selectedCompaniesIds"
          :stepNumber="5"
          class="flex1"
          stepName="Encerramento"
        />
        <StepCard
          :animated="true"
          :processes="stepsIndicators.inConcluded"
          :selectedCompaniesIds="selectedCompaniesIds"
          :stepNumber="6"
          class="flex1"
          stepName="Concluídos"
        />
      </div>
    </div>

    <div class="columns gap2">
      <div
        class="
          span-4
          medium-border-radius
          light-bordered
          offwhite-bg
          p-2
          flex
          fd-c
          fgap2
        "
      >

        <div>
          <h4 class="text-uppercase text-medium">PROCESSOS ABERTOS</h4>
          <p class="text-light">Período {{ startDateInput }} até {{ endDateInput }}</p>
        </div>

        <div class="flex fd-c fgap1">
          <HorizontalInfoCard
            :animated="true"
            :numero="proceduralMovimentsIndicatorsAtualPeriod.totalBKB"
            descricao="processos"
            sigla="BKBs"
            background="#013884"
          >
            <template #icon>
              <BoxesIcon size="80px"/>
            </template>
          </HorizontalInfoCard>
          <HorizontalInfoCard
            :animated="true"
            :numero="proceduralMovimentsIndicatorsAtualPeriod.totalFcl"
            descricao="processos"
            sigla="FCLs"
          >
            <template #icon>
              <ContainerIcon size="80px"/>
            </template>
          </HorizontalInfoCard>

          <HorizontalInfoCard
            :animated="true"
            :numero="proceduralMovimentsIndicatorsAtualPeriod.totalLcl"
            background="#17335A"
            descricao="processos"
            sigla="LCLs"
          >
            <template #icon>
              <PackageIcon size="80px"/>
            </template>
          </HorizontalInfoCard>

          <HorizontalInfoCard
            :animated="true"
            :numero="proceduralMovimentsIndicatorsAtualPeriod.totalAereo"
            background="#798C9F"
            descricao="processos"
            sigla="Aéreos"
          >
            <template #icon>
              <AirFreightIcon size="80px"/>
            </template>
          </HorizontalInfoCard>

          <HorizontalInfoCard
            :animated="true"
            :numero="proceduralMovimentsIndicatorsAtualPeriod.totalRodoviario"
            background="#818B96"
            descricao="processos"
            sigla="Rodoviários"
          >
            <template #icon>
              <DeliveryTruckIcon size="80px"/>
            </template>
          </HorizontalInfoCard>
        </div>

        <div class="flex ai-fe">
          <h2 class="text-lg text-medium" style="margin-right: 5px">
            {{ proceduralMovimentsIndicatorsAtualPeriod.total }}</h2>
          <p>PROCESSOS</p>
        </div>
      </div>

      <div
        class="
          span-4
          medium-border-radius
          light-bordered
          offwhite-bg
          p-2
          flex
          fd-c
          fgap2
        "
      >
        <div class="flex ai-fs jc-sb fgap2">
          <div>
            <h4 class="text-uppercase text-medium">GRÁFICO DE PERÍODO DE ARMAZENAGEM</h4>
            <p class="text-light">Gráfico de Percentual de Canais</p>
          </div>
          <div class="flex ai-fe">
            <h2 class="text-lg text-medium" style="margin-right: 5px">{{
                timeStorageIndicators.total
              }}</h2>
            <p>Processos</p>
          </div>
        </div>

        <Chartist
          :colors="['#004385', '#17335a', '#798c9f', '#818b96', '#a1a1a1']"
          :series="[
            {
              value: timeStorageIndicators.PRIMEIRO_PERIODO,
              meta: 'Primeiro período',
            },
            {
              value: timeStorageIndicators.SEGUNDO_PERIODO,
              meta: 'Segundo período',
            },
            {
              value: timeStorageIndicators.TERCEIRO_PERIODO,
              meta: 'Terceiro período',
            },
            {
              value: timeStorageIndicators.QUARTO_PERIODO,
              meta: 'Quarto período',
            },
            {
              value: timeStorageIndicators.OUTROS,
              meta: 'Outros',
            }
          ]"
          :showLegends="true"
          chart-name="time"
        />

        <!-- <div class="chart">
          <apexchart
            v-if="parseInt(timeStorageIndicators.total) > 0"
            :options="{
              chart: {
                type: 'donut',
                height: '100%',
                width: '100%'
              },
              colors: ['#004385', '#17335a', '#798c9f', '#818b96', '#a1a1a1'],
              dataLabels: {
                enabled: true
              },
              labels: ['Primeiro período', 'Segundo período', 'Terceiro período', 'Quarto período', 'Outros']
            }"
            :series="[
              timeStorageIndicators.PRIMEIRO_PERIODO,
              timeStorageIndicators.SEGUNDO_PERIODO,
              timeStorageIndicators.TERCEIRO_PERIODO,
              timeStorageIndicators.QUARTO_PERIODO,
              timeStorageIndicators.OUTROS
            ]"
          >
          </apexchart>
          <div class="card" v-else>
            <h5 class="text-nm text-center text-uppercase">Nenhuma informação de Registro de DIs foi encontrada.</h5>
          </div>
        </div> -->
      </div>

      <div
        class="
          span-4
          medium-border-radius
          light-bordered
          offwhite-bg
          p-2
          flex
          fd-c
          fgap2
        "
      >
        <div class="flex ai-fs jc-sb fgap2">
          <div>
            <h4 class="text-uppercase text-medium">REGISTROS DE DECLARAÇÕES DE IMPORTAÇÃO / DUIMP</h4>
            <p class="text-light">Percentual de Canais no Período de {{ startDateInput }} até
              {{ endDateInput }}</p>
          </div>
          <div class="flex ai-fe">
            <h2 class="text-lg text-medium" style="margin-right: 5px">
              {{ diRegistrationIndicators.total }}</h2>
            <p>dIs</p>
          </div>
        </div>

        <Chartist
          :colors="['#818b96', '#3B9B28', '#D6B200', '#bd0808']"
          :series="[
            {
              value: diRegistrationIndicators?.CINZA ?? 0,
              meta: 'Canal Cinza',
            },
            {
              value: diRegistrationIndicators?.VERDE ?? 0,
              meta: 'Canal Verde',
            },
            {
              value: diRegistrationIndicators?.AMARELO ?? 0,
              meta: 'Canal Amarelo',
            },
            {
              value: diRegistrationIndicators?.VERMELHO ?? 0,
              meta: 'Canal Vermelho',
            }
          ]"
          :showLegends="true"
          chart-name="regsiter"
        />

        <!-- <div class="chart">
          <apexchart
            v-if="parseInt(diRegistrationIndicators.total) > 0"
            :options="{
              chart: {
                type: 'donut',
                height: '100%',
                width: '100%'
              },
              colors: ['#818b96', '#3B9B28', '#D6B200', '#bd0808'],
              dataLabels: {
                enabled: true
              },
              labels: ['Cinza', 'Verde', 'Amarelo', 'Vermelho']
            }"
            :series="[
              diRegistrationIndicators.CINZA,
              diRegistrationIndicators.VERDE,
              diRegistrationIndicators.AMARELO,
              diRegistrationIndicators.VERMELHO
            ]"
          >
          </apexchart>
          <div class="card" v-else>
            <h5 class="text-nm text-center text-uppercase">Nenhuma informação de Registro de DIs foi encontrada.</h5>
          </div>
        </div> -->
      </div>
    </div>

    <div
      class="medium-border-radius light-bordered offwhite-bg p-2 card-columns gap2"
    >
      <div class="span-10 info-cards-title">
        <h4 class="text-uppercase text-medium">LEAD TIMES DOS PROCESSOS NO PERÍODO</h4>
        <p class="text-light">Média baseada nas datas dos processos</p>
      </div>

      <InfoCard
        :animated="true"
        :bigInfo="leadtimesIndicators.importDeclaration || 0"
        :columns="2"
        description="Dias de diferença entre Presença de Carga X Registro"
        smallInfo="DIAS"
        title="REGISTRO DE DI"
      />

      <!-- <InfoCard
        :columns="2"
        :bigInfo="leadtimesIndicators.release"
        smallInfo="DIAS"
        title="LIBERAÇÃO"
        description="Dias de diferença entre Presença de Carga X Liberação Porto"
        :animated="true"
      /> -->

      <InfoCard
        :animated="true"
        :bigInfo="leadtimesIndicators.loading || 0"
        :columns="2"
        description="Dias de diferença entre Desembaraço X Carregamento"
        smallInfo="DIAS"
        title="CARREGAMENTO"
      />

      <InfoCard
        :animated="true"
        :bigInfo="leadtimesIndicators.delivery || 0"
        :columns="2"
        description="Dias de diferença entre Presença de Carga X Entrega Confirmada ao Cliente"
        smallInfo="DIAS"
        title="ENTREGA"
      />

      <InfoCard
        :animated="true"
        :bigInfo="leadtimesIndicators.closing || 0"
        :columns="2"
        description="Dias de diferença entre Entrega X Envio do Faturamento"
        smallInfo="DIAS"
        title="ENCERRAMENTO"
      />

      <InfoCard
        :animated="true"
        :bigInfo="leadtimesIndicators.goodsReadinesDateXCustomerDeliverDate || 0"
        :columns="2"
        description="Dias de diferença entre Prontidão Confirmada X Entrega Confirmada ao Cliente"
        smallInfo="DIAS"
        titleType="slot"
      >
        <template #title>
            <h4 class="info-title mb-1">
                <span class="text-bold">PRONTIDÃO <span style="color: rgb(161, 161, 161);">X</span> ENTREGA</span>
            </h4>
        </template>
      </InfoCard>

      <div v-if="!isHercules" class="info-card-custom flex fd-c ai-c span-2 pointer"
           @click.prevent="indicatorModalOpen = true">
        <div class="top-bar-custom mb-2" style="background-color: #DEE2E6;"></div>
        <div class="text-center mb-4">
          <h4 class="big-info text-md">PERSONALIZE</h4>
          <br/>
          <p class="small-info text-nm"> Clique aqui para criar um indicador para chamar de seu!</p>
          <br/>
          <img src="https://cdn-icons-png.flaticon.com/512/158/158409.png" style="color: #DEE2E6;"
               width="50"/>
        </div>
      </div>

      <InfoCard
        v-else
        :animated="true"
        :bigInfo="herculesIndicator.length"
        :columns="2"
        cursor
        description="Processos com previsão de embarque (ETD) com atraso maior que 7 dias."
        smallInfo="PROCESSOS"
        title="ETD Atrasados"
        @click="openHerculesModal"
      />
    </div>

    <Modal
      :closeButton="true"
      :handler="indicatorModalOpen"
      :maxWidth="30"
      :useActions="true"
      @request-close="closeIndicatorModal"
    >
      <template #head>
        <h2>Personalize seu indicador</h2>
      </template>
      <template #content>
        <p class="mb-2">Descreva na caixa de texto abaixo como você deseja o seu indicador.</p>
        <textarea id="indicator-message" v-model="indicatorMessage" name="indicator-message"
                  placeholder="Descreva a sua necessidade..."></textarea>
      </template>
      <template #cancel-button>
        <button class="btn solid danger" type="button" @click="closeIndicatorModal">Cancelar
        </button>
      </template>
      <template #confirm-button>
        <button class="btn solid primary" type="button" @click="requestIndicator">Solicitar</button>
      </template>
    </Modal>

    <Modal
      :closeButton="true"
      :handler="herculesModalOpen"
      :useActions="true"
      fullWidth
      @request-close="herculesModalOpen = false"
    >
      <template #head>
        <h2>ETD Atrasados</h2>
      </template>
      <template #content>
        <Table :columns="herculesColumns" :data="herculesData" useFilter>
          <template #identification="{ item }">
            <span class="text-bold pointer" @click="openProcess(item)">{{
                item.identification
              }}</span>
          </template>
          <template #initialDatesETD="{ item }">
            <span>{{ item.initialDatesETD | moment('DD/MM/YYYY') }}</span>
          </template>
          <template #datesETD="{ item }">
            <span>{{ item.datesETD | moment('DD/MM/YYYY') }}</span>
          </template>
        </Table>
      </template>
    </Modal>

    <ModalProcess
      :data="modalData"
      :handler="modalProcessOpen"
      @request-close="() => {
        reminderOpen = false
        modalProcessOpen = false
      }"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment/moment';
import { DASHBOARD_MODULE_PERMISSION_CODE } from '@/constants/portalPermissions';
import { resolveCompaniesIdsForApi } from '@/utils/portalPermissionAccess';
import {
  CalendarIcon,
  ContainerIcon,
  PackageIcon,
  AirFreightIcon,
  DeliveryTruckIcon,
} from '@/components/Icons';

import Chartist from '@/components/Chartist.vue';
import StepCard from '@/components/StepCard.vue';
import Modal from '@/components/Modal.vue';
import ModalProcess from '@/components/ModalProcess.vue';
import HorizontalInfoCard from '@/components/HorizontalInfoCard.vue';
import InfoCard from '@/components/InfoCard.vue';
import Select from '@/components/DataInput/Select.vue';
import api from '@/services/api';
import isFullMonth from '@/utils/DateUtils';
import BoxesIcon from '@/components/Icons/BoxesIcon.vue';
import Table from './Table.vue';

export default {
  name: 'HomeGeneralTab',
  components: {
    BoxesIcon,
    // Icons
    CalendarIcon,
    ContainerIcon,
    PackageIcon,
    AirFreightIcon,
    DeliveryTruckIcon,
    // Components
    Chartist,
    Modal,
    ModalProcess,
    StepCard,
    HorizontalInfoCard,
    InfoCard,
    Table,
    Select,
  },
  data() {
    return {
      modalData: {},
      reminderOpen: false,
      modalProcessOpen: false,
      startDateInput: '',
      endDateInput: '',
      startDate: '',
      endDate: '',
      variacaoAberturaStartDate: '',
      variacaoAberturaEndDate: '',
      indicatorMessage: '',
      indicatorModalOpen: false,
      isHercules: false,
      herculesIndicator: [],
      herculesModalOpen: false,
      herculesColumns: [
        {
          name: 'PRI',
          key: 'identification',
        },
        {
          name: 'Ref. Pedido/Cliente',
          key: 'customerRef',
        },
        {
          name: 'Status',
          key: 'status',
        },
        {
          name: 'Exportador',
          key: 'exporter.name',
        },
        {
          name: 'Invoice',
          key: 'invoice',
        },
        {
          name: 'Tipo de Embarque',
          key: 'typeOfBoarding',
        },
        {
          name: 'ETD Inicial',
          key: 'initialDatesETD',
        },
        {
          name: 'ETD',
          key: 'datesETD',
        },
      ],
      herculesData: [],
      selectedCompaniesIds: [],
      initialFilterApplied: false,
    };
  },
  computed: {
    ...mapState('process', ['stepsAmount']),
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['permittedCustomerCompaniesForModule']),
    ...mapState(
      'analytics',
      [
        'leadtimesIndicators',
        'diRegistrationIndicators',
        'stepsIndicators',
        'proceduralMovimentsIndicatorsAtualPeriod',
        'timeStorageIndicators',
      ],
    ),
    userCompanies() {
      const customerCompanies = this.permittedCustomerCompaniesForModule(DASHBOARD_MODULE_PERMISSION_CODE)
        .map((company) => ({
          label: company.name.toUpperCase(),
          value: company.id,
        }));

      return [
        { label: 'TODAS', value: '' },
        ...customerCompanies,
      ];
    },
  },
  methods: {
    ...mapActions(['toggleLoading']),
    ...mapActions('auth', ['updateUser']),
    ...mapActions('process', ['getProcesses', 'getProcessDocuments', 'getProcessInvoices', 'getProcessFreightQuotationsResponses']),
    ...mapActions(
      'analytics',
      [
        'getLeadtimesIndicators',
        'clearAllIndicators',
        'getDiRegistrationIndicators',
        'getStepsIndicators',
        'getProceduralMovimentsIndicatorsAtualPeriod',
        'getTimeStorageIndicators',
      ],
    ),
    async openHerculesModal() {
      this.toggleLoading(true);
      const response = await api.get(`/api/public/customer/analytics/getProcessesByIds?ids=${this.herculesIndicator.join(',')}`);
      this.herculesData = response.data.data;
      this.toggleLoading(false);

      this.herculesModalOpen = true;
    },
    async resolveCustomerCompanies() {
      return this.permittedCustomerCompaniesForModule(DASHBOARD_MODULE_PERMISSION_CODE);
    },
    getAllCompanyOptions() {
      return this.permittedCustomerCompaniesForModule(DASHBOARD_MODULE_PERMISSION_CODE)
        .map((company) => ({
          label: company.name.toUpperCase(),
          value: company.id,
        }));
    },
    shouldUseAllCompanies(selection) {
      if (!selection || selection.length === 0) {
        return true;
      }

      const hasSpecificSelection = selection.some((option) => option && option.value);
      if (!hasSpecificSelection) {
        return true;
      }

      return selection.some((option) => option && option.value === '');
    },
    syncSelectedCompaniesIds(selection) {
      const allOptions = this.getAllCompanyOptions();

      if (allOptions.length === 0) {
        return [];
      }

      if (this.shouldUseAllCompanies(selection)) {
        return allOptions;
      }

      const permittedIds = allOptions.map((option) => option.value);

      return selection
        .filter((option) => option && option.value && permittedIds.includes(option.value))
        .map((option) => {
          const company = allOptions.find((item) => item.value === option.value);
          return company || option;
        });
    },
    tryInitialLoad() {
      const allOptions = this.getAllCompanyOptions();

      if (allOptions.length === 0) {
        return;
      }

      this.selectedCompaniesIds = this.syncSelectedCompaniesIds(this.selectedCompaniesIds);

      if (!this.initialFilterApplied) {
        this.initialFilterApplied = true;
        this.filtrarIndicadores(this.startDateInput, this.endDateInput);

        if (this.isHercules) {
          this.getHerculesIndicator(null, null);
        }
      }
    },
    resolveSelectedCompaniesIds(permittedCompanies) {
      return resolveCompaniesIdsForApi(permittedCompanies, this.selectedCompaniesIds);
    },
    async filtrarIndicadores(start, end) {
      const listCompanies = await this.resolveCustomerCompanies();
      const companiesId = this.resolveSelectedCompaniesIds(listCompanies);

      this.getIndicadores(companiesId, start, end);

      if (this.isHercules) {
        this.getHerculesIndicator(start, end);
      }
    },
    async openProcess(process) {
      this.toggleLoading(true);
      this.modalData = process;
      this.modalData.documents = await this.getProcessDocuments(process.identification);
      this.modalData.invoices = await this.getProcessInvoices(process.id);
      this.modalData.freightQuotationsResponses = await this.getProcessFreightQuotationsResponses(process.id);
      this.toggleLoading(false);
      this.modalProcessOpen = true;
    },
    async getIndicadores(companiesId, start, end) {
      this.startDate = start !== null ? `${moment(start, 'DD/MM/YYYY').format('Y-MM-DDT')}00:00:00` : `${moment(this.startDate, 'DD/MM/YYYY').format('Y-MM-DDT')}00:00:00`;
      this.endDate = end !== null ? `${moment(end, 'DD/MM/YYYY').format('Y-MM-DDT')}23:59:59` : `${moment(this.endDate, 'DD/MM/YYYY').format('Y-MM-DDT')}23:59:59`;

      const valorStart = start !== null ? start : this.startDate;
      const valorEnd = end !== null ? end : this.endDate;

      // Seta os valores nos inputs de data
      this.startDateInput = valorStart;
      this.endDateInput = valorEnd;

      this.calcularDatasVariacao(valorStart, valorEnd);

      this.toggleLoading(true);
      await this.getStepsIndicators({ companiesId });
      await this.getLeadtimesIndicators({
        startDate: this.startDate,
        endDate: this.endDate,
        companiesId,
      });
      await this.getDiRegistrationIndicators({
        startDate: this.startDate,
        endDate: this.endDate,
        companiesId,
      });
      await this.getProceduralMovimentsIndicatorsAtualPeriod({
        startDate: this.startDate,
        endDate: this.endDate,
        companiesId,
      });
      await this.getTimeStorageIndicators({
        startDate: this.startDate,
        endDate: this.endDate,
        companiesId,
      });
      this.$toast.success('Indicadores gerados com sucesso!');
      this.toggleLoading(false);
    },
    calcularDatasVariacao(startDate, endDate) {
      const startMoment = moment(startDate, 'DD/MM/YYYY');
      const endMoment = moment(endDate, 'DD/MM/YYYY');

      if (isFullMonth(startMoment, endMoment)) {
        this.variacaoAberturaStartDate = startMoment.subtract('months', 1).format('DD/MM/YYYY');
        this.variacaoAberturaEndDate = endMoment.subtract('months', 1).format('DD/MM/YYYY');
      } else {
        const difference = endMoment.diff(startMoment, 'days');

        this.variacaoAberturaEndDate = startMoment.subtract('days', 1).format('DD/MM/YYYY');
        this.variacaoAberturaStartDate = startMoment.subtract('days', difference).format('DD/MM/YYYY');
      }
    },
    async requestIndicator() {
      this.toggleLoading(true);
      const response = await api.post('/api/public/customer/analytics/enviarEmailSolicitacaoNovoIndicador', { message: this.indicatorMessage });

      if (response) {
        this.toggleLoading(false);
        this.indicatorModalOpen = false;
        this.indicatorMessage = '';
        this.$toast.success('Sua solicitação foi enviada com sucesso!');
      }
    },
    closeIndicatorModal() {
      this.indicatorModalOpen = false;
      this.indicatorMessage = '';
    },
    async getHerculesIndicator(startDate, endDate) {
      const firstDate = startDate != null ? `${moment(startDate, 'DD/MM/YYYY').format('Y-MM-DDT')}00:00:00` : this.startDate;
      const secondDate = endDate != null ? `${moment(endDate, 'DD/MM/YYYY').format('Y-MM-DDT')}23:59:59` : this.endDate;

      const herculesIndicatorResponse = await api.get(`/api/public/customer/analytics/getHerculesEtdIndicator?firstDate=${firstDate}&secondDate=${secondDate}`);
      this.herculesIndicator = herculesIndicatorResponse.data.data;
    },
  },
  mounted() {
    // dados que realmente devem ser enviados para o endpoint
    const valueStart = moment().startOf('month').format('DD/MM/YYYY');

    const valueEnd = moment().format('DD/MM/YYYY');

    this.startDate = valueStart;
    this.endDate = valueEnd;

    // Seta os valores nos inputs de data
    this.startDateInput = valueStart;
    this.endDateInput = valueEnd;

    this.calcularDatasVariacao(valueStart, valueEnd);

    this.tryInitialLoad();
  },
  destroyed() {
    this.clearAllIndicators();
  },
  watch: {
    userCompanies: {
      handler(companies) {
        if (companies.length <= 1) {
          return;
        }

        this.tryInitialLoad();
      },
    },
    selectedCompaniesIds: {
      deep: true,
      handler(selection) {
        if (this._syncingCompanies) {
          return;
        }

        const normalized = this.syncSelectedCompaniesIds(selection);
        const currentIds = (selection || [])
          .filter((option) => option && option.value)
          .map((option) => option.value)
          .sort()
          .join(',');
        const normalizedIds = normalized.map((option) => option.value).sort().join(',');

        if (currentIds !== normalizedIds) {
          this._syncingCompanies = true;
          this.selectedCompaniesIds = normalized;
          this.$nextTick(() => {
            this._syncingCompanies = false;
          });
        }
      },
    },
    user: {
      deep: true,
      handler(value) {
        if (value.companies !== undefined && value.companies.length > 0) {
          this.isHercules = value.companies.filter((a) => a.federalID === '07442711000165').length > 0;
        }
      },
    },
  },
};
</script>

<style scoped>
.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
}

.filter-header__info {
  flex: 1 1 auto;
  min-width: 280px;
}

.filter-header__controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1.25rem;
  flex: 0 0 auto;
  margin-left: auto;
}

.filter-header__controls > * {
  flex-shrink: 0;
}

.filter-header__field--companies {
  width: 240px;
}

.filter-header__field--companies ::v-deep .styled-select,
.filter-header__field--companies ::v-deep .styled-select .select-list {
  width: 100%;
}

.filter-header__field--companies ::v-deep .styled-select .select-list .selected-option {
  width: 100%;
}

@media screen and (max-width: 1643px) {
  .filter-header {
    flex-wrap: wrap;
  }

  .filter-header__info {
    flex: 1 1 100%;
    min-width: 0;
  }

  .filter-header__controls {
    flex: 1 1 100%;
    justify-content: flex-start;
    margin-left: 0;
  }
}

@media screen and (max-width: 768px) {
  .filter-header {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-header__controls {
    flex-direction: column;
    align-items: stretch;
    margin-left: 0;
    width: 100%;
  }

  .filter-header__field--companies {
    width: 100%;
  }

  .filter-header__controls .btn {
    width: 100%;
  }
}

.steps-cards-row > * {
  flex: 1 1 155px;
  min-width: 155px;
}

.card-columns {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
}

.chart {
  max-height: 420px;
  overflow: hidden;
}

@media screen and (max-width: 1024px) {
  .card-columns {
    grid-template-columns: 1fr;
  }

  .info-cards-title {
    grid-column: span 1;
  }
}

.info-card-custom {
  border: 1px solid #DEE2E6;
  border-radius: var(--medium-border-radius);
  padding: 0.75rem;
  background-color: var(--white-color);
}

.top-bar-custom {
  width: 100%;
  height: 6px;
}

@media screen and (max-width: 1024px) {
  .info-card-custom {
    grid-column: span 1;
  }
}
</style>
